import React from 'react'
import { Alert } from 'react-bootstrap'

import { Spaces } from '../../components/Spaces.js'
import { ButtonPrimaryOutlined } from '../../components/Buttons.js'
import telegram_delphe_qr from "../../resources/images/telegram_delphe_qr.png"
import { SwapOutlined } from '@ant-design/icons'


export class Slide_EchangeTokens_Temp extends React.PureComponent {
    render() {
        const tokenName = "Delphe"

        return (
            <div style={{ overflowX: "hidden" }}>

                <h1><SwapOutlined /><Spaces count="3" />
                    Buy or sell {tokenName}
                </h1>
                <br />

                <Alert variant="light">
                    <i style={{ fontSize: "25px", marginRight: "10px" }} className="fa fa-info-circle" />
                    Purchases and sales can be made by contacting the administrators of {tokenName}.
                    Use the QR code or the button below.
                    DMALtd stands for "Delphe Market Analysis Ltd".
                </Alert>

                <a href="https://t.me/DMALtd" target="_blank">
                    <ButtonPrimaryOutlined>
                        open on telegram &nbsp;&nbsp;
                        <i className="fa fa-external-link" />
                    </ButtonPrimaryOutlined>
                </a>

                <br /><br />

                <p className="top-center">
                    <span>
                        <img
                            id="telegram-qr-code"
                            src={telegram_delphe_qr}
                            alt="telegram-qr-code"
                            style={{
                                width: "45%",
                                height: "45%",
                                display: "block",
                                marginLeft: "auto",
                                marginRight: "auto",
                            }}
                        />
                    </span>
                </p>

            </div>
        )
    }
}
